import { render, staticRenderFns } from "./RappelsTableComponent.vue?vue&type=template&id=ed0fe30a&"
import script from "./RappelsTableComponent.vue?vue&type=script&lang=js&"
export * from "./RappelsTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports